export default {
  basename: process.env.NODE_ENV === 'production' ? '/quickshop/' : '/',
  api: {
    baseUrl: '/sv/api/quickshop/',
    csrftokenHeaderName: "X-CSRFToken",
    csrftokenCookieName: "csrftoken",
  }
}
